module.exports = __webpack_public_path__ + "img/xiaozi_quanlianlu.6fddf594.png";